import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="relative">
        <img
          src="/logo-s.png"
          alt="CMS Logo"
          className="w-32 h-32 object-contain animate-logo-loader"
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;
